<template>
  <b-form novalidate @submit.prevent="submit" class="ml-auto mr-auto">
    <b-row>
      <b-col v-if="showError" class="col-12 col-md-6 mb-3">
        <b-card>
          <p v-if="showError === 'save'" class="text-center">{{ $t('apiary.form.error') }}</p>
          <p v-if="showError === 'not found'" class="text-center">{{ $t('apiary.form.not_found') }}</p>
        </b-card>
      </b-col>
    </b-row>
    <template v-if="showError !== 'not found'">
      <b-form-group label-for="title">
        <b-form-input :placeholder="$t('apiary.form.title.label')" id="title" v-model="form.title" type="text" required :state="$v.form.title.$dirty ? !$v.form.title.$error : null" @blur="$v.form.title.$touch"></b-form-input>
      </b-form-group>
      <b-form-group label-for="zip-code">
        <b-form-input :placeholder="$t('apiary.form.zipCode.label')" id="zip-code" v-model="form.zipCode" type="text" required :state="$v.form.zipCode.$dirty ? !$v.form.zipCode.$error : null" @blur="$v.form.zipCode.$touch"></b-form-input>
      </b-form-group>
      <b-row v-if="loading">
        <b-col class="col-12 mb-3">
          <div class="d-flex justify-content-around flex-row mb-3"><b-spinner></b-spinner></div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12 col-md-6 mb-3">
          <b-link class="bg-transparent h-100 text-primary border-primary border form-control text-center" :title="$t('apiary.form.cancel')" @click.prevent="cancel()">
            {{ $t('apiary.form.cancel') }}
          </b-link>
        </b-col>
        <b-col class="col-12 col-md-6 mb-3">
          <b-button class="d-block w-100" type="submit" variant="primary">{{ $t('apiary.form.submit') }}</b-button>
        </b-col>
      </b-row>
    </template>
    <b-modal :id="'offLineModalApiraySave'" centered hide-header-close @ok="hideModal" class="network-modal">
      <template slot="modal-title">
        {{ $t('offLineModal.title') }}
      </template>
      {{ $t('offLineModal.text') }}
      <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
        <b-button size="lg" class="mt-3" @click="ok()">
          {{ $t('offLineModal.ok') }}
        </b-button>
      </template>
    </b-modal>
  </b-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ApiaryForm',
  props: ['id'],
  data () {
    return {
      showError: false,
      loading: false,
      form: {
        title: null,
        zipCode: null
      }
    }
  },
  methods: {
    showOffLineModal () {
      this.$bvModal.show('offLineModalApiraySave')
    },
    hideModal () {
      this.$bvModal.hide('offLineModalApiraySave')
    },
    async submit () {
      if (navigator.onLine) {
        this.$v.form.$touch()
        if (!this.$v.$error) {
          this.loading = true
          let result
          try {
            const token = await this.$api.user.getToken()
            result = await this.$api.apiaries.save({ id: this.id, title: this.form.title, zipCode: this.form.zipCode, token })
            this.loading = false
          } catch (e) { // network error etc.
            if (e.response && e.response.status === 403) {
              this.loading = false
              this.$router.replace('/login')
            }

            result = false
          }

          this.showError = (!result ? 'save' : false)

          if (result) {
            this.$router.replace('/apiaries')
          }
        }
      } else {
        this.showOffLineModal()
      }
    },
    cancel () {
      this.$router.replace('/apiaries')
    }
  },
  validations: {
    form: {
      title: {
        required
      },
      zipCode: {
        required
      }
    }
  },
  async mounted () {
    if (this.id) {
      try {
        const result = await this.$api.apiaries.getOne(this.id)
        const data = Object.values(result.data.result)
        if (data[0]) {
          this.form.title = data[0].title
          this.form.zipCode = data[0].field_zip
        } else {
          this.showError = 'not found'
        }
      } catch (e) {
        this.showError = 'not found'
      }
    }
  }
}
</script>

<style scoped>
  form {
    max-width: 500px;
    font-family: "Roboto Condensed", sans-serif;
  }
</style>
